import Login from "../../components/auth/login";
import Header from "../../components/header";

const LoginPage = () => {
  return (
    <>
      <Header />
      <Login />
    </>
  );
};
export default LoginPage;
